import errorReporter from '@app/errorReporter';

const bbInternalCoopTimeChangeComponent = {
  bindings: {},
  controller: InternalCoopTimeChangeController,
  controllerAs: 'vm',
  template: `<appointment-book ng-if="vm.appointment" appointment-details="vm.appointment" />`,
};

InternalCoopTimeChangeController.$inject = [
  '$routeParams',
  'AppointmentBookService',
  'ToastService',
];

function InternalCoopTimeChangeController(
  $routeParams,
  AppointmentBookService,
  ToastService,
) {
  const vm = this;
  vm.$onInit = () => {
    vm.appointmentId = $routeParams.appointmentId;

    AppointmentBookService.getAppointmentAndListingForCoop(vm.appointmentId)
      .then(data => {
        vm.appointment = data;
      })
      .catch(err => {
        ToastService.add({
          type: 'danger',
          message: 'Failed to load the showing information',
        });
        errorReporter.error(err);
      });
  };
}

export default bbInternalCoopTimeChangeComponent;
